import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import RegValidatePage from '../components/login/RegValidatePage';
import '../css/style.css';
import '../components/Home.css';

class RegValidateLayout extends Component {

    render(){
        const { params } = this.props.match
        return (
            <SimpleLayout>
                <RegValidatePage uuid={params.uuid} userId={params.userId}/>
            </SimpleLayout>              
        );
    }

}

export default RegValidateLayout;